export const objectManagementMixin = {
  mounted() {
    this.requiredFieldsFilled();
  },

  methods: {
    updateField: _.debounce(function(event, field) {
      let parsedValue = event;
      switch (field.inputType) {
        case 'radio':
          parsedValue = event === 'True' ? true : false
          break;
        default:
          break;
      }

      let eventName = 'update-object';
      if (field.varName === "sm_loss_value") {
        eventName = 'update-loss-value'
      }

      this.$emit(eventName, { varName: field.varName, value: parsedValue});

      this.requiredFieldsFilled();
    }, 200),

    parseSelectValue(selectedItems, options) {
      let value = '';
      if (options && selectedItems) {
        selectedItems.forEach((item, index) => {
          let itemObject = options.find(option => option.code === item)
          if (itemObject) {
            if (itemObject.client_label) {
              value += itemObject.client_label
            } else if (itemObject.libelle) {
              value += itemObject.libelle
            } else if (itemObject.name) {
              value += itemObject.name
            } else if (itemObject.label) {
              value += itemObject.label
            } else {
              value += itemObject.code
            }
            value += index < selectedItems.length-1 ? ' / ' : ''
          }
        })
      }
      return value;
    },

    /**
     * Emits an event to update the attribute that indicates if the required specific fields are correctly filled
     */
    requiredFieldsFilled() {
      this.$emit("update-required-field", this.requiredFieldsValidation());
    },

    valuesAreDifferent(currentValue, originalValue) {
      if (typeof(currentValue) === typeof(originalValue)) {
        if (Array.isArray(currentValue)) {
          return !_.isEmpty(_.xor(currentValue, originalValue))
        } else {
          return currentValue !== originalValue;
        }
      } else {
        return true;
      }
    },
  }
};


// WEBPACK FOOTER //
// ./src/mixins/objectManagementMixin.js